"use client";

import Link from "next/link";
import { FC, useCallback } from "react";

import { useGetProfile } from "@/features/events/hooks/use-get-profile.hook";
import { Typography } from "@/shared/ui";

import { TABS, TabValues } from "../../constants/tabs.constant";

import styles from "./footer.module.scss";
import { CommonFooterProps } from "./footer.types";
import { useGetUnreadMessagesCounter } from "./hooks";

const CommonFooter: FC<CommonFooterProps> = ({ activeTab, onDoubleClick }) => {
  const { data: user } = useGetProfile();
  const { data } = useGetUnreadMessagesCounter();

  const getLinkHref = useCallback(
    (tabValue: TabValues, url: string) => {
      if (tabValue === "event") {
        switch (user?.role) {
          case "alpha":
            return `${url}/rest`;
          case "muse":
            return `${url}/date-nights`;
        }
      }
      return url;
    },
    [user]
  );

  return (
    <footer className={styles.commonFooter}>
      {TABS.map(({ value, activeIcon, defaultIcon, url }) => (
        <Link
          key={value}
          href={getLinkHref(value, url)}
          className={styles.tab}
          onClick={() => value === activeTab && onDoubleClick?.()}
        >
          {value === "messages" && data?.count ? (
            <div className={styles.messagesCounter}>
              <Typography variant="caption-2" align="center" />
            </div>
          ) : null}

          {value === activeTab ? activeIcon : defaultIcon}
        </Link>
      ))}
    </footer>
  );
};

export { CommonFooter };
